import { Box, Typography } from '@mui/material';
import {
  gridFilterModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import { useLocalization } from '@/hooks/useLocalization';

/**
 * Empty state for a holdings grid whose search runs on the server.
 *
 * Such a grid stays mounted when a search matches nothing, so that the term can
 * still be cleared, which means the empty state has to say which kind of
 * emptiness the user is looking at.
 */
export const NoHoldingsRowsOverlay = () => {
  const { t } = useLocalization();
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const hasActiveSearch = (filterModel.quickFilterValues ?? []).length > 0;

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography>
        {hasActiveSearch
          ? t('noHoldingsMatchSearch', 'No holdings match your search.')
          : t('noHoldingsDataAvailable', 'No holdings data available.')}
      </Typography>
    </Box>
  );
};

export default NoHoldingsRowsOverlay;
